import { useEffect } from "react";
import { ReactElement } from "react";
import { Action, State } from "../../state/state";
import { CalculationTable } from "../zoning-plan-common/CalculationTable";
import { calculate } from "calculation/calculate";
import { MetricValues } from "calculation/metric";
import { ParameterValues } from "calculation/parameter";
import { ReportLinks } from "components/zoning-plan-common/ReportLinks";
import { NoData } from "components/common/NoData";

export function Calculation(props: {
  dispatch: (action: Action) => void;
  state: State;
}): ReactElement {
  const dispatch = props.dispatch;
  const state = props.state;

  useEffect(() => {
    async function calculateCapacity() {
      if (
        state.metrics !== undefined &&
        state.zoningPlanLegal.scenario !== undefined &&
        state.zoningPlanLegal.parameterSet !== undefined &&
        state.zoningPlanLegal.calculationState === undefined &&
        state.selectedMunicipality !== undefined
      ) {
        const metricValues = new MetricValues(
          state.zoningPlanLegal.scenario.metricValues
        );

        const parameterValues = new ParameterValues(
          state.zoningPlanLegal.parameterSet.parameterValues
        );

        const calculationState = await calculate(
          state.metrics,
          metricValues,
          parameterValues,
          state.zoningPlanLegal.scenario
        );

        dispatch({
          type: "setCalculationStateLegal",
          data: {
            calculationState: calculationState,
          },
        });
      }
    }

    calculateCapacity();
  }, [
    state.metrics,
    state.zoningPlanLegal.scenario,
    state.zoningPlanLegal.parameterSet,
    state.zoningPlanLegal.calculationState,
    state.selectedMunicipality,
    dispatch,
  ]);

  const hasData =
    state.metrics !== undefined &&
    state.selectedMunicipality !== undefined &&
    state.zoningPlanLegal.scenario !== undefined &&
    state.zoningPlanLegal.parameterSet !== undefined;

  return (
    <div className="flex flex-col text-gray-700 max-w-[800px]">
      {!hasData && <NoData />}
      {hasData && state.zoningPlanLegal.calculationState !== undefined && (
        <>
          <h1 className="text-lg font-bold mb-2">
            Zusammenfassung der Bauzonenkapazität
          </h1>
          <p className="mb-4">
            Folgende Kennwerte wurden auf Basis des rechtskräftigen Zonenplans
            berechnet.
          </p>
          <div className="p-4 grid grid-cols-2 gap-y-2 gap-x-2 items-center bg-gray-100">
            <CalculationTable
              metrics={state.metrics!}
              scenario={state.zoningPlanLegal.scenario!}
              municipality={state.selectedMunicipality!}
              calculationState={state.zoningPlanLegal.calculationState!}
            />
          </div>
          <div className="flex flex-col space-y-2 bg-gray-100 p-4">
            <h2 className="font-bold">Downloads</h2>
            <ReportLinks
              metrics={state.metrics!}
              calculationState={state.zoningPlanLegal.calculationState!}
              municipality={state.selectedMunicipality!}
              scenario={state.zoningPlanLegal.scenario!}
              parameterSetModifiedAt={state.zoningPlanLegal.parameterSet!.modifiedAt}
            />
          </div>
        </>
      )}
    </div>
  );
}
